/**
 * Canonical `primaryResourceType` values accepted by the Journal feed
 * filter shape. Centralised here so callers (drill-down panels, the
 * tournament step Journal tab, future surfaces) reference a single
 * source of truth instead of duplicating string literals.
 */
export enum JournalResourceType {
  TEAM = "team",
  TOURNAMENT_STEP = "tournament_step",
  MATCH = "match",
}

/**
 * Backwards-compatible alias preserved so existing call sites
 * (`JOURNAL_RESOURCE_TYPES.TEAM`, etc.) keep working without churn.
 * New code should reference {@link JournalResourceType} directly.
 */
export const JOURNAL_RESOURCE_TYPES = JournalResourceType;
